export const PAGE_VIEW_SETTING = [
  { view_id: 'showFeatureConfig', active_menu: 'deliveryDeployMng', action: 'ShowFeatureFeiShuDocument' }
]

const pageView = {}

export function genratePageSharUrl(params) {
  let item = []
  for (const key in params) {
    if (params[key]) {
      item.push(key + '=' + params[key])
    }
  }
  window.getSelection().removeAllRanges()
  let ur = item.join('&')
  const dom = document.createElement('input')
  let protocol = document.location.protocol
  let hostName = document.location.hostname
  let port = document.location.port
  if (port != 80) {
    dom.value = protocol + '//' + hostName + ':' + port + '/#/gotoAction?' + ur
  } else {
    dom.value = protocol + '//' + hostName + '/#/gotoAction?' + ur
  }

  document.body.appendChild(dom)
  dom.select()
  document.execCommand('copy')
  document.body.removeChild(dom)
}

for (const iterator of PAGE_VIEW_SETTING) {
  pageView[iterator.view_id] = iterator
}

export default pageView
